import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";
import ProductSaleItem from "./ProductSaleItem";
import styled from "@emotion/styled";
import JumboScrollbar from "@jumbo/components/JumboScrollbar";
import JumboDemoCard from "@jumbo/components/JumboDemoCard";
import { Box, CircularProgress } from "@mui/material";
import Datagrid from "app/Common/Datagrid";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  borderBottom: "none",
  paddingTop: theme.spacing(1.5),
  paddingBottom: theme.spacing(1.5),
}));

const ProductSalesList = ({
  reportingTabsData,
  action,
  columns,
  tabLoaders,
}) => {
  // console.log("reportingTabsData", reportingTabsData);
  return (
    <>
      <JumboDemoCard
        wrapperSx={{
          //pt: 2,
          backgroundColor: "background.paper",
          height: "600px",
          padding: "10px",
          paddingBottom: "10px !important",
        }}
        sx={{ margin: "2px" }}
      >
        {tabLoaders && tabLoaders.length && tabLoaders.indexOf(action) != -1 ? (
          <Box sx={{ position: "relative" }}>
            <CircularProgress
              sx={
                {
                  //zIndex: 4,
                  //position: "absolute",
                  // top: 0,
                  // left: 0,
                  // right: 0,
                  // margin: "auto",
                  // transform: "translate(-50%, -50%)",
                  // transform: "-webkit-translate(-50%, -50%)",
                  // transform: "-moz-translate(-50%, -50%)",
                  // transform: "-ms-translate(-50%, -50%)",
                }
              }
            />
          </Box>
        ) : reportingTabsData &&
          reportingTabsData[action] &&
          reportingTabsData[action].data &&
          reportingTabsData[action].data.length ? (
          // <JumboScrollbar
          //   autoHeight={true}
          //   autoHideTimeout={4000}
          //   autoHeightMin={274}
          //   autoHide={true}
          //   hideTracksWhenNotNeeded
          // >
          //   <Table>
          //     <TableHead>
          //       <TableRow>
          //         {columns.map((column, index) => (
          //           <StyledTableCell key={index}>
          //             {column.toUpperCase()}
          //           </StyledTableCell>
          //         ))}
          //       </TableRow>
          //     </TableHead>
          //     <TableBody>
          //       {reportingTabsData[action].data.map((product, index) => (
          //         <ProductSaleItem
          //           item={product}
          //           key={index}
          //           columns={columns}
          //         />
          //       ))}
          //     </TableBody>
          //   </Table>

          // </JumboScrollbar>
          <Datagrid
            columns={columns}
            rows={reportingTabsData[action].data}
            footer={true}
            rowId={true}
            stackReportingMetrics={true}
          />
        ) : (
          <Box sx={{ position: "relative" }}>No data available.</Box>
        )}
      </JumboDemoCard>
    </>
  );
};
/* Todo products prop define */
export default ProductSalesList;
